import { z } from 'zod';

export enum ErrorClass {
  ERROR_CLASS_2 = 'ERROR_CLASS_2',
  ERROR_CLASS_1 = 'ERROR_CLASS_1',
}

export const ErrorClassSchema = z.nativeEnum(ErrorClass);

export const PlatformComponentDowntimeSchema = z.object({
  errorClass: ErrorClassSchema,
  durationSec: z.number(),
});

export type PlatformComponentDowntime = z.infer<
  typeof PlatformComponentDowntimeSchema
>;

export const PlatformComponentDaySchema = z.object({
  date: z.date(),
  downtimes: z.array(PlatformComponentDowntimeSchema),
});

export type PlatformComponentDay = z.infer<typeof PlatformComponentDaySchema>;

export const PlatformComponentSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().optional(),
  activeErrorClass: ErrorClassSchema.optional(),
  uptime: z.number(), // uptime for the selected day range
  days: z.array(PlatformComponentDaySchema),
});

export type PlatformComponent = z.infer<typeof PlatformComponentSchema>;
